import { Location } from '@angular/common';
import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { AudioRecordingService } from '@app/_core/services/audio-recording.service';
import { CampaignService } from '@app/_core/services/campaign.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { AssignAgentsComponent } from '@app/pages/common/assign-agents/assign-agents.component';
import { EMPTY, catchError, map } from 'rxjs';
import { Utils } from '@app/_core/helper/Utils';
import { any } from 'underscore';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { AppService } from '@app/_core/services/app.service';
import { HeaderComponent } from '@app/_core/components/header/header.component';

@Component({
  selector: 'app-ivr-details',
  templateUrl: './ivr-details.component.html',
  styleUrls: ['./ivr-details.component.scss'],
})
export class IvrDetailsComponent implements OnInit {
  option: { key: string; value: number }[] = [];
  selectedvalues: Number;

  @ViewChild(AssignAgentsComponent)
  private assignAgentComponent!: AssignAgentsComponent;

  IVRDetail: any;
  IVRPromptQueues: any;
  title: string = '';

  userRoles: any = [];
  users: any;
  IVRPromtIDList: any = [];
  type: any;
  //"group", "user", this.service(), "GetGroupUsers", false, false, true, !cls.
  owner = 'group';
  object = 'user';
  priorities = false;
  persistence = false;
  roles = true;
  disable;
  details: any;
  channels: any = [{ label: 'Voice' }, { label: 'Text' }];
  PromptType: any = [{ label: 'Switch' }, { label: 'API' }];
  channelTypes: any = [{ label: 'Test1' }, { label: 'Test2' }];
  Eventtype: any = [{ label: 'None' }];
  selectedChannel: any;
  selectedChannelType: any;
  selectedMessageSource: any = {};
  isRecording: any;
  messageSource: any = [];
  AppendAudioType: any = [];
  savingAudioFileMessage: any = '';
  private audio: HTMLAudioElement;
  recordedfilesToPlay: HTMLAudioElement[] = [];
  recordedfilesToPlayFailurePromtMesaage: HTMLAudioElement[] = [];
  durationforaudio: any;
  recordedTime: any;
  blobUrl: any;
  blobData: any;
  savingRecordingFileMessage: any = '';
  selectedAPIMethod: any;
  APIMethodTypes: any = [];
  IVRPromptFailureTypes: any = [];
  IVRPromptFailureByTypes: any = [];
  MessagepromtChange: any = {};
  id: any;
  storage: any;
  recordedfiles: any = [];
  recordedFilesFailMessage: any = [];
  recordedfileNames: string = '';
  recordedfileNamesToPush: string = '';
  recordedfileNamesForFailedMessage: string = '';
  audioFileMessage: any = [];
  audioFileMessageFailedPromt: any = [];
  audioFileMessageName: any = [];
  audioFileToSave: any = [];
  audioFileFailureMessageToSave: any = [];
  audioFileFailureMessage: any = [];
  audioFileMessageNameFailedPromt: string = '';
  clientAbbreviation: any = '';
  fileIndexToPlay = 0;
  fileIndexToFailedMessagePlay = 0;
  enablePreviousBtn: boolean = false;
  enableFailedPromtPreviousBtn: boolean = false;
  iVRPromptQueuesName: any;
  iVRPromptQueuesId: any;
  iVRDetailForName: any;
  channelID: any;
  typeID: any;
  description: any;
  message: string;
  failureMessage: any;
  name: any;
  iVRPrompts: any = [];
  maxRetries: any;
  failurePrompt: any;
  apiMethod: any;
  attributes: any;
  recordedfilesToSave: any = [];
  recordedfilesToPush: any = [];
  audiofilesToPush: any = [];
  recordedfilesToSaveMessage: any = [];
  recordedfilesFailureMessage: any = [];
  resultMultiplefile: any = [];
  saveFailureMessage: any = [];
  isPreviewEnable: boolean = true;
  isFailurePreviewEnable: boolean = true;
  activeButton: string | null = null;
  isPublic: boolean = true;
  messageSourceList: string[] = [];
  currentIndex = 0;
  stopRecordingTimeout: any;
  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string,
    private campaignService: CampaignService,
    private sanitizer: DomSanitizer,
    private audioRecordingService: AudioRecordingService,
    private route: ActivatedRoute,
    private router: Router,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private location: Location,
    private utils: Utils,
    private appService: AppService,
    private headerComponent: HeaderComponent,
    private webStorageService: WebStorageService
  ) {
    this.route.params.subscribe((params: any) => {
      console.log(params);
      // alert(params.id)
      this.loadIVRDetails(params.id);
      this.GetIVRPromptQueues(params.id);
    });

    this.audio = new Audio();
    // Audio
    this.audioRecordingService.recordingFailed().subscribe(() => (this.isRecording = false));
    this.audioRecordingService.getRecordedTime().subscribe(time => (this.recordedTime = time));
    this.audioRecordingService.getRecordedBlob().subscribe(data => {
      this.blobData = data;
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
    });

    const urlArray: any = this.router.url.split('/');
    urlArray.shift();
    if (urlArray.length > 0) {
      for (let i = 0; i < urlArray.length - 1; i++) {
        this.currentpath += urlArray[i] + (urlArray[i + 2] ? '>' : '');
      }
    }
    this.disable = this.securityService.validateGrant('ManageAssignments');
    console.log('this.currentpath', this.currentpath);
  }

  ngOnInit(): void {
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');

    this.messageSource = [
      { label: 'Upload File', value: 'uploadfile' },
      { label: 'Real-Time Recording', value: 'recording' },
    ];

    this.AppendAudioType = [
      { label: 'Prompt Message', value: 'Prompt Message' },
      { label: 'Failure Message', value: 'Failure Message' },
    ];

    console.log(this.messageSource);
    console.log(this.AppendAudioType);
    this.selectedMessageSource = { value: '-1', label: 'Select one' };
    this.MessagepromtChange = { value: 'Prompt Message', label: 'Prompt Message' };
    this.GetIVRPromptAPIMethods();
    this.GetIVRPromptTypes();

    this.audio.addEventListener('ended', () => {
      console.log(`Duration: ${this.audio.duration} seconds`);
      if (this.fileIndexToPlay < this.recordedfilesToPlay.length) {
        this.audio.src = this.recordedfilesToPlay[this.fileIndexToPlay].toString();
        this.audio.load();
        this.audio.play();
        this.fileIndexToPlay++;
      }
    });
    this.audio.addEventListener('ended', () => {
      console.log(`Duration: ${this.audio.duration} seconds`);
      if (this.fileIndexToFailedMessagePlay < this.recordedfilesToPlayFailurePromtMesaage.length) {
        this.audio.src = this.recordedfilesToPlayFailurePromtMesaage[this.fileIndexToFailedMessagePlay].toString();
        this.audio.load();
        this.audio.play();
        this.fileIndexToFailedMessagePlay++;
      }
    });
    this.audio.addEventListener('ended', () => this.playNext());
  }
 playCurrent() {
    if (this.currentIndex < this.messageSourceList.length) {
      this.audio.src = this.messageSourceList[this.currentIndex];
      this.audio.load();
      this.audio.play().catch(err => console.error("Playback error:", err));
    }
  }
 playNext() {
    this.currentIndex++;
    this.playCurrent();
  }
  currentpath: any = '';

  loadIVRDetails(id: number) {
    this.managerService
      .GetIVRPromptsByID(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetIVRPromptsByID');
          if (isValid) {
            this.IVRDetail = data.Response.Data;
            this.name = this.IVRDetail.Name;
            this.channelID = this.IVRDetail.ChannelID;
            this.typeID = this.IVRDetail.ID;
            this.description = this.IVRDetail.Description;
            this.message = this.IVRDetail.Message;
            this.failureMessage = this.IVRDetail.FailureMessage;
            console.log(this.IVRDetail.Message);
            let A = this.IVRDetail.Message;
            console.log(A);
            if (data.Response.Data.IVRPrompts.length >= 1) {
              this.IVRDetail = data.Response.Data;
              this.iVRPrompts = this.IVRDetail.IVRPrompts;
            } else if (data.Response.Data.IVRPrompts.length >= 2) {
              this.iVRDetailForName = data.Response.Data;
            }
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();

    // const data: any =  lastValueFrom(this.managerService.GetIVRPromptsByID(id));
    // this.IVRPromtIDList = data.Response.Data;
    //  console.log(data.Response.Data)
    let selectedIVR = null;
    if (this.IVRDetail && this.IVRDetail.IVRPrompts) {
      this.IVRDetail.IVRPrompts.forEach((element: any) => {
        if (element.IVRPromptTypeID == id) this.selectedAPIMethod = element.Type;
        console.log(this.selectedAPIMethod);
        {
          selectedIVR = element;
        }
      });
    }

    console.log('id', id, this.IVRDetail);
    this.IVRDetail = selectedIVR;
    // this.selectedAPIMethod = this.IVRDetail[0];
    // console.log(this.selectedAPIMethod);
    //if (selectedIVR)
    const isValid = ResponseHandler.processResponse(this.IVRDetail, 'GetIVRPromptsByID');

    if (isValid) {
      //this.campaignDetail = data.Response.Data;
      this.title =
        'Campaign ' +
        this.IVRDetail.ID +
        ' - ' +
        this.IVRDetail.Name +
        (this.IVRDetail.Manager == null ? '' : ' (Manager: ' + this.IVRDetail.Manager + ')');

      this.details = {
        ID: this.IVRDetail.ID,
        owner: this.owner,
        object: this.object,
        service: this.managerService,
        method: 'GetGroupUsers',
        priorities: this.priorities,
        persistence: this.persistence,
        roles: this.roles,
        disable: !this.securityService.validateGrant('ManageAssignments'),
      };
    }
  }

  GetIVRPromptAPIMethods() {
    this.managerService.GetIVRPromptAPIMethods().subscribe(response => {
      response.Response.Data.forEach(element => {
        this.APIMethodTypes.push({ label: element.Name, value: element.MethodID });
      });
    });
  }
  unsorted() {}
  GetIVRPromptTypes() {
    const IVRPromptTypes = [];

    this.managerService.GetIVRPromptTypes().subscribe(response => {
      IVRPromptTypes.push(response.Response.Data);
      console.log(IVRPromptTypes);
      console.log(this.option.push(response.Response.Data));

      this.IVRPromptFailureTypes = response.Response.Data;

      //console.log(this.IVRPromptFailureTypes.push(response.Response.Data))
      //let IVRPromptFailureTypes
      //this.option = this.object.key(IVRPromptTypes).map(key=>
      // ({key,value:IVRPromptTypes[key]}));
      // const filteredSections = [name,type];
      //const arr: [{ name: string }] = [  ]
      //filteredSections.push(this.IVRPromptFailureTypes);
      // this.IVRPromptFailureTypes.forEach(element => {
      //   filteredSections.push(element);
      //   console.log(filteredSections);
      // });
      // response.Response.Data.forEach(element => {
      //   this.IVRPromptFailureTypes.push({label: element});
      //  console.log(this.IVRPromptFailureTypes)
      // });
    });
  }
  onOptionsSelected(event) {
    this.IVRPromptFailureByTypes = [];
    //refresh:true
    const value = event.target.value;
    this.type = value;
    this.GetIVRPromptsByType(this.type);
  }
  GetIVRPromptsByType(type: number) {
    this.managerService.GetIVRPromptsByType(type).subscribe(response => {
      console.log(response);
      response.Response.Data.forEach(element => {
        this.IVRPromptFailureByTypes.push({ label: element.Name });
        //console.log( label: element.Name)
      });
    });
  }
  GetIVRPromptQueues(id: number) {
    const isValid = this.managerService.GetIVRPromptQueues(id).subscribe(response => {
      if (isValid) {
        this.IVRPromptQueues = response.Response.Data;
        if (response.Response.Data.length > 0) {
          this.IVRPromptQueues = response.Response.Data;
          if (this.IVRPromptQueues.length != 0) {
            this.iVRPromptQueuesName = this.IVRPromptQueues[0].Name;
            this.iVRPromptQueuesId = this.IVRPromptQueues[0].ID;
          }
        }
        // this.IVRPromptQueues = response.Response.Data;
        // if (this.IVRPromptQueues.length != 0) {
        //   this.iVRPromptQueuesName = this.IVRPromptQueues[0].Name;
        //   this.iVRPromptQueuesId = this.IVRPromptQueues[0].ID;
        // }
        // if (this.IVRPromptQueues[0].ID >= 1 && this.IVRPromptQueues[0].Name.length >= 1) {
        //   //this.iVRPromptQueuesId = this.IVRPromptQueues[0].ID;
        //   this.iVRPromptQueuesName = this.IVRPromptQueues[0].Name;
        //   this.iVRPromptQueuesId = this.IVRPromptQueues[0].ID;
        // }
      }
      console.log(this.IVRPromptQueues);
    });
  }

  saveChangesEdit(id: number) {
    //this.router.navigate([this.clientAbbreviation + '/Console/Queues/Details/' + id]);
    //this.router.navigateByUrl(this.clientAbbreviation + '/Console/Queues/Details/');
    //this.router.navigate([this.clientAbbreviation + '/Console/Queues']);
    if (this.IVRPromptQueues[0].ID >= 1) {
      this.router.navigate([this.clientAbbreviation + '/Console/Queues/Details/' + id]);
      const currMenu = {
        listmenu: this.clientAbbreviation + '/Console',
        menu: 'Queues',
        submenu: '',
        name: 'Queues',
        action: this.clientAbbreviation + '/Console/Queues/Details/' + id,
      };
      this.appService.setCurrentMenu(currMenu);
      this.headerComponent.changeUserStatusHeader();
    }
  }

  saveChanges() {
    //this.router.navigate([this.clientAbbreviation+'/Console/Queues/Details' +id]);
    //  this.router.navigate(['/BCH/Console/Queues/Details/13'] , {
    //   replaceUrl: true
    // })
    const pl: any = {};
    // const agents = [];
    // const assignedAgents = this.assignAgentComponent.assignedDisplay;
    // for (const agent of assignedAgents) {
    //   agents.push(agent.value + '|' + this.getUserRole(agent.label));
    // }
    // pl.agents = agents;
    pl.id = this.IVRDetail.ID;
    //let a = this.recordedfilesToSaveMessage(',');
    if (this.recordedfilesToSaveMessage.length <= 0 && this.IVRDetail?.Message.length > 0) {
      this.recordedfilesToSaveMessage = this.IVRDetail?.Message;
    }
    if (this.saveFailureMessage.length <= 0 && this.IVRDetail?.FailureMessage.length > 0) {
      this.saveFailureMessage = this.IVRDetail?.FailureMessage;
    }

    const data = {
      name: this.name,
      channelID: this.channelID,
      typeID: this.IVRDetail.IVRPromptTypeID,
      description: this.description,
      //message: this.recordedfilesToSaveMessage + '' + this.IVRDetail?.Message,
      message: this.recordedfilesToSaveMessage,
      // this.recordedfilesToSaveMessage && this.IVRDetail?.Message
      //   ? '{this.recordedfilesToSaveMessage ).join('
      //   : ')} ${this.IVRDetail?.Message}:null',
      // failureMessage: this.IVRDetail.FailureMessage,
      //failureMessage: this.saveFailureMessage + '\n' + this.IVRDetail?.FailureMessage,
      failureMessage: this.saveFailureMessage,
      iVRPrompts: [{ id: 96, value: 'default', requestType: '', eventTypeID: -1, priority: '', color: '' }],
      id: this.IVRDetail.ID,
      maxRetries: this.IVRDetail.MaxRetries,
      failurePrompt: this.IVRDetail.FailurePromptID,
      apiMethod: this.IVRDetail.ApiMethod,
      attributes: null,
    };
    this.managerService
      .EditIVRDetails(data)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'EditIVRDetails');
          if (isValid) {
            this.location.back();
          }
        })
      )
      .subscribe();
  }

  getUserRole(label: any) {
    if (label.lastIndexOf(' (Manager)') > -1) {
      return 2;
    } else return 1;
  }
  goBack() {
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
    this.location.back();
  }

  onMessageSourceChange() {
    const sourceValue = this.selectedMessageSource.value;

    console.log(sourceValue);

    if (sourceValue === 'recording') {
      this.isRecording = true;
    }
  }
  onMessagepromtChange() {
    const sourceValue = this.MessagepromtChange.value;

    console.log(sourceValue);
  }
  handleFileInput(event) {
    this.savingAudioFileMessage = 'Saving File';
    //let input = event.target.files[0];
    const input = event.target;
    if (!input.files?.length) {
      this.savingAudioFileMessage = '';
      return;
    }

    const file = input.files[0];
    const fileExt = event.target.files[0].name.split('.').pop();
    const path = (window.URL || window.webkitURL).createObjectURL(file);
    console.log('path', path, fileExt);
    if (this.MessagepromtChange.value === 'Prompt Message') {
      this.audioFileMessage.push(file.name);
      this.audioFileMessageName = this.audioFileMessage.join('\n');
    } else if (this.MessagepromtChange.value == 'Failure Message') {
      this.audioFileMessageFailedPromt.push(file.name);
      this.audioFileMessageNameFailedPromt = this.audioFileMessageFailedPromt.join('\n');
    }

    if (fileExt === 'wav' || fileExt === 'mp3') {
      this.loadAudio(path); // for preview
    }
    if(this.selectedMessageSource.value === 'uploadfile' || this.selectedMessageSource.value === 'recording')
    {
      this.isPublic = true;
    } else {
      this.isPublic = false;
    }
    this.campaignService.uploadFile(file, fileExt, this.isPublic, '').subscribe(response => {
      console.log('saveFile', response);
      this.savingAudioFileMessage = response.Response.Data.Name;
      if (this.MessagepromtChange.value === 'Prompt Message') {
        this.audioFileToSave = response.Response.Data.URL;
        this.recordedfilesToPush.push(this.audioFileToSave);
        this.recordedfilesToSaveMessage = this.recordedfilesToPush.join('\n') + '\n' + this.IVRDetail?.Message;
      } else if (this.MessagepromtChange.value == 'Failure Message') {
        this.audioFileFailureMessage = response.Response.Data.URL;
        this.audiofilesToPush.push(this.audioFileFailureMessage);
        if (this.IVRDetail?.FailureMessage.length > 1) {
          this.saveFailureMessage = this.audiofilesToPush.join('\n') + '\n' + this.IVRDetail?.FailureMessage;
        } else {
          this.saveFailureMessage = this.audiofilesToPush.join('\n');
        }
      }
      // this.addnewCampaignForm.patchValue({ messageDescription: response.Response.Data.URL });
      //console.log(this.addnewCampaignForm.value);
    });
  }

  onfailureMessageChange(currentFailureMessage: any, updatefailuremessage: any) {
    console.log(currentFailureMessage, updatefailuremessage);
  }
//   async previewMessage() {
//     this.activeButton = 'preview';
//     this.isPreviewEnable = false;

//     this.fileIndexToPlay = 0;
//     if (this.recordedfilesToPlay.length >= 1) {
//       this.audio.src = this.recordedfilesToPlay[this.fileIndexToPlay].toString();
//       this.audio.load();
//       this.audio.play();
//       this.fileIndexToPlay++;
//     }

//     // let filepath: string[] = this.message
//     //   .split('\n')
//     //   .map(path => path.trim())
//     //   .filter(path => path.length > 0);
// const input = this.message;
// // Match and split after each extension while keeping it attached
// const filepath: string[] = input
//   .split(/(?<=\.(?:wav|mp3|flac))/i)
//   .map(path => path.trim())
//   .filter(path => path.length > 0);
//     console.log(filepath);
//     filepath.forEach((message: any) => {
//       if(message.includes('s3') || message.includes('S3')){
//         this.playlist.push(message);
//         this.isS3File= true;
//       }
//       else{
//       this.managerService.getRecordingFiles(message).subscribe(data => {
//         console.log(data);
//         if (data.MimeType == 'audio/wav') {
//           const binaryData = 'data:audio/wav;base64,' + data.result;
//           const binary = Utils.convertDataURIToBinary(binaryData);
//           const blob = new Blob([binary], { type: 'audio/wav' });
//           const blobUrl = URL.createObjectURL(blob);
//           this.playlist.push(blobUrl);
//           this.isS3File = true;
//           //this.audio.src = blobUrl;
//           // this.audio.load();
//           //this.audio.play();
//         }
//         if (data.MimeType == 'audio/mp3') {
//           const binaryData = 'data:audio/wav;base64,' + data.result;
//           const binary = Utils.convertDataURIToBinary(binaryData);
//           const blob = new Blob([binary], { type: 'audio/mp3' });
//           const blobUrl = URL.createObjectURL(blob);
//           this.audio.src = blobUrl;
//           //this.loadAudioFile(blobUrl);
//           this.audio.play();
//         }
//       });
//     }
//     });
//     if(this.playlist.length>0){
//       this.playCurrent();
//     }
    
//   }
async previewMessage() {
  this.activeButton = 'preview';
  this.isPreviewEnable = false;
  this.fileIndexToPlay = 0;

  if (this.recordedfilesToPlay.length >= 1) {
    this.audio.src = this.recordedfilesToPlay[this.fileIndexToPlay].toString();
    this.audio.load();
    this.audio.play();
    this.fileIndexToPlay++;
  }

  const input = this.message;
  const filepath: string[] = input
    .split(/(?<=\.(?:wav|mp3))/i)
    .map(path => path.trim())
    .filter(path => path.length > 0);

  console.log(filepath);

  const fetchPromises = filepath.map((message: string) => {
    if (message.includes('s3') || message.includes('S3')) {
      this.messageSourceList.push(message);
      return Promise.resolve(); 
    } else {
      return new Promise<void>((resolve) => {
        this.managerService.getRecordingFiles(message).subscribe(data => {
          console.log(data);
          const mimeType = data.MimeType;
          const binaryData = `data:${mimeType};base64,` + data.result;
          const binary = Utils.convertDataURIToBinary(binaryData);
          const blob = new Blob([binary], { type: mimeType });
          const blobUrl = URL.createObjectURL(blob);
          this.messageSourceList.push(blobUrl);
          resolve();
        });
      });
    }
  });

  await Promise.all(fetchPromises);

  if (this.messageSourceList.length > 0) {
    this.playCurrent();
  }
}

  // previewMessageIVRPrompts() {
  //   this.activeButton = 'ivrPreview';
  //   this.isFailurePreviewEnable = false;
  //   this.fileIndexToFailedMessagePlay = 0;
  //   if (this.recordedfilesToPlayFailurePromtMesaage.length >= 1) {
  //     this.audio.src = this.recordedfilesToPlayFailurePromtMesaage[this.fileIndexToFailedMessagePlay].toString();
  //     this.audio.load();
  //     this.audio.play();
  //     this.fileIndexToFailedMessagePlay++;
  //   }
  //   let filepathfailureMessage: string[] = this.failureMessage
  //     .split('\n')
  //     .map(path => path.trim())
  //     .filter(path => path.length > 0);
  //   console.log(filepathfailureMessage);

  //   filepathfailureMessage.forEach((message: any) => {
  //     this.managerService.getRecordingFiles(message).subscribe(data => {
  //       console.log(data);
  //       if (data.MimeType == 'audio/wav') {
  //         const binaryData = 'data:audio/wav;base64,' + data.result;
  //         const binary = Utils.convertDataURIToBinary(binaryData);
  //         const blob = new Blob([binary], { type: 'audio/wav' });
  //         const blobUrl = URL.createObjectURL(blob);
  //         this.audio.src = blobUrl;
  //         // this.audio.load();
  //         this.audio.play();
  //       }
  //       if (data.MimeType == 'audio/mp3') {
  //         const binaryData = 'data:audio/wav;base64,' + data.result;
  //         const binary = Utils.convertDataURIToBinary(binaryData);
  //         const blob = new Blob([binary], { type: 'audio/mp3' });
  //         const blobUrl = URL.createObjectURL(blob);
  //         this.audio.src = blobUrl;
  //         //this.loadAudioFile(blobUrl);
  //         this.audio.play();
  //       }
  //     });
  //   });
  //   //this.audio.play();
  //   // if (this.message && !Array.isArray(this.message)) {
  //   //   this.message = [this.message];
  //   //   this.message.forEach((message: any) => {
  //   //     this.managerService.getRecordingFiles(message).subscribe(data => {
  //   //       console.log(data);
  //   //       if (data.MimeType == 'audio/wav') {
  //   //         const binaryData = 'data:audio/wav;base64,' + data.result;
  //   //         const binary = Utils.convertDataURIToBinary(binaryData);
  //   //         const blob = new Blob([binary], { type: 'audio/wav' });
  //   //         const blobUrl = URL.createObjectURL(blob);
  //   //         this.loadAudioFile(blobUrl);
  //   //         this.audio.play();
  //   //       }
  //   //       if (data.MimeType == 'audio/mp3') {
  //   //         const binaryData = 'data:audio/wav;base64,' + data.result;
  //   //         const binary = Utils.convertDataURIToBinary(binaryData);
  //   //         const blob = new Blob([binary], { type: 'audio/mp3' });
  //   //         const blobUrl = URL.createObjectURL(blob);
  //   //         this.loadAudioFile(blobUrl);
  //   //         this.audio.play();
  //   //       }
  //   //     });
  //   //   });
  //   // }
  //   // const fileExt = this.IVRDetail.Message.files.name.split('.').pop();
  //   // const path = (window.URL || window.webkitURL).createObjectURL(file);
  //   // console.log('path', path, fileExt);
  //   //this.blobUrl =this.IVRDetail.Message
  //   // this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.IVRDetail.Message));
  //   //   this.loadAudio(this.blobUrl.changingThisBreaksApplicationSecurity);
  //   //   this.saveFile();
  //   // const binaryData = this.IVRDetail.Message
  //   // const binary = Utils.convertDataURIToBinary(binaryData);
  //   // const blob = new Blob([binary], { type: 'audio/wav' });
  //   // const blobUrl = URL.createObjectURL(blob);
  //   //this.audioSource = blobUrl;
  // }

  async previewMessageIVRPrompts() {
    this.activeButton = 'ivrPreview';
    this.isFailurePreviewEnable = false;
    this.fileIndexToFailedMessagePlay = 0;
    if (this.recordedfilesToPlayFailurePromtMesaage.length >= 1) {
      this.audio.src = this.recordedfilesToPlayFailurePromtMesaage[this.fileIndexToFailedMessagePlay].toString();
      this.audio.load();
      this.audio.play();
      this.fileIndexToFailedMessagePlay++;
    }
    const input = this.failureMessage;
    let filepathfailureMessage: string[] = input
    .split(/(?<=\.(?:wav|mp3))/i)
    .map(path => path.trim())
    .filter(path => path.length > 0);
    console.log(filepathfailureMessage);

    const fetchPromises = filepathfailureMessage.map((message: any) => {
      if (message.includes('s3') || message.includes('S3')) {
        this.messageSourceList.push(message);
        return Promise.resolve(); 
      }
      else{
        return new Promise<void>((resolve) => {
          this.managerService.getRecordingFiles(message).subscribe(data => {
            console.log(data);
            const mimeType = data.MimeType;
            const binaryData = `data:${mimeType};base64,` + data.result;
            const binary = Utils.convertDataURIToBinary(binaryData);
            const blob = new Blob([binary], { type: mimeType });
            const blobUrl = URL.createObjectURL(blob);
            this.messageSourceList.push(blobUrl);
            resolve();
          });
        });
      }
    });
    await Promise.all(fetchPromises);

    if (this.messageSourceList.length > 0) {
      this.playCurrent();
    }
  }
  cancelPreviewMessage() {
    this.activeButton = null;
    this.isPreviewEnable = true;
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
  }

  cancelPreviewMessageIVRPrompts() {
    this.activeButton = null;
    this.isFailurePreviewEnable = true;
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
  }
  loadAudioFile(audioFilePath) {
    console.log('loadAudio', audioFilePath);
    this.audio.src = audioFilePath;
    this.audio.load();
  }

  loadAudio(audioFilePath) {
    console.log('loadAudio', audioFilePath);
    console.log(this.audio);
    if (this.MessagepromtChange.value === 'Prompt Message') {
      this.enablePreviousBtn = true;
      this.audio.src = audioFilePath;
      this.recordedfilesToPlay.push(audioFilePath);
      console.log(this.recordedfilesToPlay);
    } else if (this.MessagepromtChange.value == 'Failure Message') {
      this.enableFailedPromtPreviousBtn = true;
      this.audio.src = audioFilePath;
      this.recordedfilesToPlayFailurePromtMesaage.push(audioFilePath);
    }
    // console.log('loadAudio', audioFilePath);
    // console.log(this.audio);
    // this.audio.src = audioFilePath;
    // this.recordedfilesToPlay.push(audioFilePath);
    // //this.previewMessagedetails.emit({audioFilePath});
    // console.log(audioFilePath);
    //this.audio.load();
    //this.disablePreviewBtn = false;
    //this.previewBtnText = 'Preview';
  }
  startRecording() {
    this.savingRecordingFileMessage = '';
    if (this.isRecording) {
      this.audioRecordingService.startRecording();
      this.isRecording = false;
    }
  }
  stopRecording() {
    this.savingRecordingFileMessage = 'Saving file...';
    if (!this.isRecording) {
      this.audioRecordingService.stopRecording();
      this.isRecording = true;
      //this.download();
      this.stopRecordingTimeout = setTimeout(() => {
        this.loadAudio(this.blobUrl.changingThisBreaksApplicationSecurity);
        this.saveFile();
      }, 1000);
    }
  }
  ngOnDestroy() {
    this.stopRecordingTimeout && clearTimeout(this.stopRecordingTimeout);
  }
  saveFile() {
    if(this.isRecording == true){
      this.isPublic = true;
    }else{
      this.isPublic = false;
    }
    fileNames: any;
    let newFileNames = '';
    this.campaignService.saveFile(this.blobData?.blob, this.isPublic).subscribe(response => {
      console.log('saveFile', response);
      //this.addnewCampaignForm.patchValue({messageDescription: response.Response.Data.URL});
      this.savingRecordingFileMessage = response.Response.Data.URL.split('/').pop();
      if (this.MessagepromtChange.value === 'Prompt Message') {
        this.recordedfiles.push(this.savingRecordingFileMessage);
        this.recordedfileNames = this.recordedfiles.join('\n');
        this.audioFileMessageName = response.Response.Data.URL;
        this.recordedfilesToSave.push(this.audioFileMessageName);
        this.recordedfilesToSaveMessage = this.recordedfilesToSave.join('\n') + '\n' + this.IVRDetail?.Message;
        this.enablePreviousBtn = true;
      } else if (this.MessagepromtChange.value == 'Failure Message') {
        this.recordedFilesFailMessage.push(this.savingRecordingFileMessage);
        this.recordedfileNamesForFailedMessage = this.recordedFilesFailMessage.join('\n');
        this.recordedfileNamesForFailedMessage = response.Response.Data.URL;
        this.recordedfilesFailureMessage.push(this.recordedfileNamesForFailedMessage);
        if (this.IVRDetail?.FailureMessage.length > 1) {
          this.saveFailureMessage = this.recordedfilesFailureMessage.join('\n') + '\n' + this.IVRDetail?.FailureMessage;
        } else {
          this.saveFailureMessage = this.recordedfilesFailureMessage.join('\n');
        }
        //this.saveFailureMessage = this.recordedfilesFailureMessage.join('\n') + '\n' + this.IVRDetail?.FailureMessage;
        this.enableFailedPromtPreviousBtn = true;
      }

      this.clearRecordedData();
    });
  }
  clearRecordedData() {
    this.blobUrl = null;
  }
}
